var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainicons1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26205 20.1037C7.97279 20.3909 7.63023 20.6178 7.25393 20.7716C6.87763 20.9254 6.47496 21.003 6.06892 20.9999C5.66288 20.9968 5.26141 20.9132 4.88743 20.7538C4.51346 20.5943 4.17431 20.3622 3.88934 20.0707C3.60437 19.7791 3.37917 19.4339 3.22659 19.0546C3.07401 18.6754 2.99705 18.2695 3.00009 17.8603C3.00313 17.451 3.08611 17.0464 3.24431 16.6695C3.4025 16.2926 3.6328 15.9508 3.92207 15.6635L12.7824 4.47275C13.2251 4.0101 13.7553 3.64145 14.3416 3.38852C14.9278 3.1356 15.5584 3.00352 16.1962 3.00007C16.8339 2.99662 17.4658 3.12188 18.0548 3.36845C18.6437 3.61502 19.1777 3.97792 19.6254 4.43576C20.073 4.8936 20.4251 5.43712 20.661 6.03428C20.8969 6.63144 21.0119 7.27015 20.999 7.91278C20.9862 8.5554 20.8458 9.18894 20.5863 9.77604C20.3267 10.3631 19.9531 10.8919 19.4876 11.3312L8.26205 20.1037Z",
    stroke: "#D6BBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59172 18.5952C7.25722 18.5952 7.79672 18.0549 7.79672 17.3884C7.79672 16.7219 7.25722 16.1816 6.59172 16.1816C5.92622 16.1816 5.38672 16.7219 5.38672 17.3884C5.38672 18.0549 5.92622 18.5952 6.59172 18.5952Z",
    stroke: "#D6BBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1833 10.1479C17.5171 10.1479 18.5983 9.06731 18.5983 7.73434C18.5983 6.40138 17.5171 5.3208 16.1833 5.3208C14.8495 5.3208 13.7683 6.40138 13.7683 7.73434C13.7683 9.06731 14.8495 10.1479 16.1833 10.1479Z",
    stroke: "#D6BBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainicons1);
export default __webpack_public_path__ + "static/media/main icons (1).83167981039b55584822e3899f7330cc.svg";
export { ForwardRef as ReactComponent };